import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useSetAtom } from 'jotai';
import React, { useEffect } from 'react';
import { Image } from 'react-native';
import { match } from 'ts-pattern';
import CloseIcon from '@/assets/icon/close.svg';
import { hasShownGuideForReviewPhotoAtom, hasShownGuideForToiletPhotoAtom, } from '@/atoms/User';
import { ScreenLayout } from '@/components/ScreenLayout';
import * as S from './PlacePhotoGuideScreen.style';
// 방문리뷰/화장실은 기존 1페이지 가이드를 그대로 유지한다(사용자 확정 사항).
export default function PlacePhotoGuideScreen({ route, navigation, }) {
    const { target } = route.params;
    const setHasShownGuideForReviewPhoto = useSetAtom(hasShownGuideForReviewPhotoAtom);
    const setHasShownGuideForToiletPhoto = useSetAtom(hasShownGuideForToiletPhotoAtom);
    useEffect(() => {
        if (target === 'review') {
            setHasShownGuideForReviewPhoto(true);
        }
        else if (target === 'toilet') {
            setHasShownGuideForToiletPhoto(true);
        }
    }, []);
    const guideMessages = match(target)
        .with('review', () => [
        '내부 공간이 잘 보이게 촬영해 주세요',
        '좌석이나 통로가 잘 드러나도록\n다양한 각도에서 찍어주세요',
    ])
        .with('toilet', () => [
        '내부 공간이 잘 보이게 촬영해 주세요',
        '화장실 넓이, 세면대 높이가 잘 드러나도록\n가슴 높이에서 찍어주세요(키 150cm 이상 기준)',
    ])
        .exhaustive();
    const guideImage = match(target)
        .with('review', () => require('../../assets/img/guide_review.png'))
        .with('toilet', () => require('../../assets/img/guide_toilet.png'))
        .exhaustive();
    return (_jsxs(ScreenLayout, { isHeaderVisible: false, safeAreaEdges: ['top', 'bottom'], style: { backgroundColor: '#262629' }, children: [_jsx(S.Header, { children: _jsx(S.CloseButton, { elementName: "place_photo_guide_close_button", onPress: navigation.goBack, children: _jsx(CloseIcon, { width: 24, height: 24, color: "white" }) }) }), _jsx(S.SampleImage, { children: _jsx(Image, { style: { width: '100%', height: '100%' }, source: guideImage }) }), _jsxs(S.GuideMessage, { children: [_jsx(S.GuideMessageTitle, { children: "\uD83D\uDCA1\uC0AC\uC9C4 \uCD2C\uC601 TIP!" }), _jsx(S.BulletPoints, { children: guideMessages.map((message, index) => (_jsxs(S.BulletPointContainer, { children: [_jsx(S.BulletPoint, { children: '•' }), _jsx(S.GuideMessageContent, { children: message })] }, index))) })] })] }));
}
